import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { api, API } from 'modules/api';
import useModalAction from 'modules/modals/hooks/useModalAction';
import { ModalType } from 'modules/modals/constants';
import { AccountDataContext } from 'modules/context';

export const useUpdateUserConsentStatus = () => {
  const [isApiSubmitting, setIsApiSubmitting] = useState(false);
  const [successfullyVerified, setSuccessfullyVerified] = useState(false);
  const { modalShow, modalHide } = useModalAction();
  const errorModal = useRef<string | null>(null);
  const active = useRef(true);
  const { accountDataContext, setAccountDataContext } =
    useContext(AccountDataContext);
  const showErrorModal = useCallback(() => {
    errorModal.current = modalShow({
      onClose: () => {
        !!errorModal.current && modalHide(errorModal.current);
        errorModal.current = null;
      },
      title: 'Error',
      text: 'There was an error trying to send your data. Please try again later',
      type: ModalType.INFO,
    });
  }, [modalHide, modalShow]);

  const updateUserConsentStatus = useCallback(
    async email => {
      try {
        setIsApiSubmitting(true);
        const obj = { email: email };
        const handleResetcheck = await api(
          API.POST_UPDATE_USER_CONSENT_STATUS(obj),
        );
        if (handleResetcheck.data.result === true) {
          setAccountDataContext({
            ...accountDataContext,
            policyAccepted: true,
          });

          setIsApiSubmitting(false);
          setSuccessfullyVerified(true);
        }
      } catch (error) {
        active.current && showErrorModal();
      } finally {
        active.current && setIsApiSubmitting(false);
      }
    },
    [showErrorModal],
  );
  useEffect(() => {
    return () => {
      active.current = false;
    };
  }, []);
  return {
    successfullyVerified,
    updateUserConsentStatus,
    isApiSubmitting,
  };
};
